import { useState, useCallback, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

// Hook for admin page
export const useAdmin = () => {
    const [userList, setUserList] = useState([]);
    
    // Fetch user list to display on admin dashboard
    const fetchUsers = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth-admin/list-users`, {
                method: 'GET',
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                setUserList(data);
                return true;
            } else {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            setUserList(null);
            return false;
        }
    }, []);

    // Allow admin to delete users
    const deleteUser = async (uname) => {
        try {
            // Send POST request to delete user from the appropriate route in the API
            const response = await fetch(`${API_BASE_URL}/auth-admin/delete-user`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ uname })
            });
            
            const responseText = await response.text(); // read the raw message
            console.log("Backend response status:", response.status);
            console.log("Backend response body:", responseText);

            if (!response.ok) { throw new Error(`Failed to delete user ${uname}`) }

            fetchUsers();

        } catch (error) {
            console.log(error);
        }    
    }

    // Allow admin to add users
    const addUser = async (uname, upass) => {
        try {
            // Send POST request to add user from the appropriate route in the API
            const response = await fetch(`${API_BASE_URL}/auth-admin/add-user`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ uname, upass })
            });
            
            const responseText = await response.text(); // read the raw message
            console.log("Backend response status:", response.status);
            console.log("Backend response body:", responseText);

            if (!response.ok) { throw new Error(`Failed to add user ${uname}`) }

            fetchUsers();
            return { success: true, message: responseText };
            
        } catch (error) {
            console.log(error);
            return { success: false, message: error.message };
        }
    }

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return {
        fetchUsers,
        deleteUser,
        addUser,
        userList
    }
}

export default useAdmin;